import { Component, ReactNode } from 'react';
import { Button, Card } from 'react-bootstrap';

import './BCard.css';

interface BCardProps {
    title: string,
    contentPanel: ReactNode,
    bottomPanel: ReactNode,
}

class BCard extends Component<BCardProps> {

    constructor(props: BCardProps) {
        super(props);
    }

    render() {
        const { title, contentPanel, bottomPanel } = this.props;

        return (
            <Card style={{ width: '40rem' }}>
                <Card.Body>
                    <Card.Header>{title}</Card.Header>
                    <br />
                    <Card.Text>
                        {contentPanel}
                    </Card.Text>
                    <br />
                    <div className="quizstart-button">
                        {bottomPanel}
                    </div>
                </Card.Body>
            </Card>
        )
    };
}

export default BCard;